import React from 'react';
import Box from '@amzn/awsui-components-react/polaris/box';
import Button from '@amzn/awsui-components-react/polaris/button';
import Container from '@amzn/awsui-components-react/polaris/container';
import Grid from '@amzn/awsui-components-react/polaris/grid';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import { AppLayout } from '../../components/Layout';
import { useAuth } from '../../contexts/AuthContext';
import { ListOfVideos } from './components/ListOfVideos';
import { projectTitle } from '../../constants';
import { navigationBreadcrumbs } from '../../pages/uploadfilescommon/breadcrumbs';

const HomeContent: React.FC = () => {
  const { username } = useAuth();

  return (
    <Box margin={{ bottom: 'l' }}>
      <div className="custom-home__header">
        <Box padding={{ vertical: 'xxxl', horizontal: 's' }}>
          <Grid
            gridDefinition={[
              { colspan: { l: 8, xxs: 10 }, offset: { l: 2, xxs: 1 } },
              { colspan: { xl: 6, l: 5, s: 6, xxs: 10 }, offset: { l: 2, xxs: 1 } },
              { colspan: { xl: 2, l: 3, s: 4, xxs: 10 }, offset: { s: 0, xxs: 1 } },
            ]}
          >
            <Box fontWeight="light" padding={{ top: 'xs' }}>
              <span className="custom-home__category"></span>
            </Box>
            <div className="custom-home__header-title">
              <Box variant="h1" fontWeight="heavy" padding="n" fontSize="display-l" color="inherit">
                {projectTitle}
              </Box>
              <Box fontWeight="light" padding={{ bottom: 's' }} fontSize="display-l" color="inherit">
                Generate captions/subtitles for your videos
              </Box>
              <Box variant="p" fontWeight="light">
                <span className="custom-home__header-sub-title">
                  {projectTitle} is a self-service tool to generate captions in SRT or VTT formats. 
                  It's powered by Amazon Transcribe which automatically converts speech to text. 
                  How cool is that?!
                </span>
              </Box>
            </div>
            <div className="custom-home__header-cta">
              <Container>
                <SpaceBetween size="xl">
                  <Box variant="h2" padding="n">
                    Get started here, {username}
                  </Box>
                  <Box>
                    Valid file formats: MP3, MP4, MOV, WAV, FLAC, AMR, OGG, WebM, M4A, and AAC.
                  </Box>
                  <Button href="/uploadfiles" variant="primary">
                    Upload file(s)
                  </Button>
                </SpaceBetween>
              </Container>
            </div>
          </Grid>
        </Box>
      </div>
      <div>
        <ListOfVideos />
      </div>
    </Box>
  );
};

const Homepage: React.FC = () => {
  // We'll use the global FeedbackModal from App.tsx
  return (
    <AppLayout 
      content={<HomeContent />}
      breadcrumbs={navigationBreadcrumbs}
    />
  );
};

export default Homepage;
